import Breadcrumbs, { BreadcrumbItem } from './Breadcrumbs';

export type { BreadcrumbItem };
export default Breadcrumbs;
